import { observer } from 'mobx-react';
import { ThreeDots } from 'react-loader-spinner';

const GeneralLoader = observer(({ text = '', wrapClassName = '' }) => {
  const showText = !!text;

  const classNames = ['loader-wrapper'];
  if (wrapClassName) {
    classNames.push(wrapClassName);
  }

  return (
    <div className={classNames.join(' ')}>
      <div className="content">
        <ThreeDots width={48} height={12} color="#348CF9" />
        {showText && <div>{text}</div>}
      </div>
    </div>
  );
});

export default GeneralLoader;
